import { Chip, XIcon } from '@keplerco/core';
import React from 'react';
import Accordion from '../../../../components/accordion/accordion';
import { EmptyState } from '../../../../components/general/empty-state/empty-state';
import { OptionButton } from '../../../../components/general/option-button/option-button';
import { TertiaryButton } from '../../../../components/general/tertiary-button/tertiary-button';
import { RatingAssessmentAccordionEmptyStateImage } from './rating-assessment-accordion-empty-state.image';
import styles from './rating-assessment-accordion.module.css';
import { PeerAssessmentAssigneeResponse } from '../../../../overmind/actions';
import { AssessmentAssigneeListItemLayout } from '../../../../components/assessment/assessment-entity-list-item.layout';

export function AssessorsAccordion({ assignee, onAdd, onRemove }: { assignee: PeerAssessmentAssigneeResponse; onAdd: () => void; onRemove: (learnerSlug: string) => void }) {
  function AccordionHeader() {
    return (
      <div className={styles.accordionHeader}>
        <AssessmentAssigneeListItemLayout assignee={assignee}>
          <Chip customTheme={{ backgroundColor: 'white', borderColor: 'baby-blue', color: 'text' }}>
            {assignee.reviewers.length} {assignee.reviewers.length === 1 ? 'assessor' : 'assessors'}
          </Chip>

          <TertiaryButton
            type="button"
            onClick={e => {
              e.stopPropagation();
              onAdd();
            }}
          >
            Add
          </TertiaryButton>
        </AssessmentAssigneeListItemLayout>
      </div>
    );
  }

  return (
    <Accordion header={<AccordionHeader />}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {!!assignee.reviewers.length ? (
          <>
            <h6>{`The following people will assess ${assignee.fullName}`}</h6>
            {assignee.reviewers.map(reviewer => (
              <OptionButton style={{ width: '100%', display: 'grid', gridTemplateColumns: '1fr 1fr 100px', textAlign: 'start' }} key={reviewer.learnerSlug} onClick={() => onRemove(reviewer.learnerSlug)}>
                <div>{reviewer.fullName}</div>
                <div>{reviewer.roles?.map(role => role.name).join(', ')}</div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'flex-end' }}>
                  {reviewer.learnerSlug === assignee.learnerSlug && <Chip customTheme={{ backgroundColor: 'white', borderColor: 'baby-blue', color: 'text' }}>Self</Chip>}
                  {reviewer.isManager && <Chip customTheme={{ backgroundColor: 'white', borderColor: 'baby-blue', color: 'text' }}>Manager</Chip>}
                  <XIcon size={16} />
                </div>
              </OptionButton>
            ))}
          </>
        ) : (
          <EmptyState title="" subtitle={`The selected assessors will display here`} imageElement={<RatingAssessmentAccordionEmptyStateImage />} />
        )}
      </div>
    </Accordion>
  );
}

